
import React, { useState, useReducer, useEffect, useRef } from "react";
// import SuperSearch from '../../shared/SuperSearch/SuperSearch';
import { enumUtil } from "../../../utils/Enum";
import isNull from "../../../utils/NullChecking";
import SuperSearchList from "../../shared/SuperSearch/SuperSearchList";
import Table from "../../Setup/Shared/Table";
import Loader from "../../shared/Loader/Loader";
// import '../../shared/SuperSearch/SuperSearch.module.css'
import GridColumnHeader from "../../Setup/Shared/GridColumnHeader"
import { useDispatch, useSelector } from "react-redux";
import format from 'date-fns/format';
import Menu from '@mui/material/Menu';
import { DateRangePicker } from 'react-date-range';
import CalendaRangeInput from "../../General/CalendarRangeInput";
import SearchHeader from '../../Setup/Shared/SearchHeader';
import { Autocomplete, TextField } from "@mui/material";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import AmountFormatter from "../../../utils/AmountFormatter";
import handleCopyText from "../../shared/CopyData";
import { connect } from "react-redux"
import useHandleOpenNewBrowserTab from "../../shared/NewTabBrowser/useHandleOpenNewBrowserTab";
import SuperSearchMultiple from "../../shared/SuperSearch/SuperSearchMultiple";
import SuperSearchMultipleClient from "../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";
import { MainBarActiveTabsAction } from "../../../actions/MainBarActiveTabsAction";
import usePagination from "../../../customhooks/usePagination";
import HandleSelectColumnName from "../../../utils/HandleSelectColumnName";


const OverPaymentReport = (props) => {
    const { type, Settings } = { ...props };
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);
    let ActiveReport = useSelector(state => state.Open_Report_Tab?.find((re) => re.active));
    let SidebarActive = useSelector(state => state.SidebarActiveTab);
    const API_URL_GENERAL = enumUtil.controller.General
    const API_URL = enumUtil.controller.Claim
    const API_Report = enumUtil.controller.Report
    const API_URL_Patient = enumUtil.controller.Patient

    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
    //   const API_URL_CLAIM = enumUtil.controller.Claim
    const Search_Data = {
        // "DOSFrom": null,
        // "DOSTo": null,
        "CheckNumber": "",
        "InsuranceID": "-1",
        "ProviderID": "-1",
        "LocationID": "-1",
        "PatientIDs": "-1",
        "ClaimID": "",
        "DOSFrom": null,
        "DOSTo": null,
        "EntryDateFrom": null,
        "EntryDateTo": null,
    }
    const dispatch = useDispatch();
    const initialLoad = useRef(false);
    const [copiedText, setCopiedText] = useState({});
    const [is, setIs] = useState(false);
    const [patientValue, setPateintValue] = useState([])
    const [PatientDD, setPatientDD] = useState([])
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    const [writeOffPatientReportsData, setWriteOffPatientReportData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [searchParam, setSearchParam] = useState(Search_Data);
    const [initialInsurance, setinitialInsurance] = useState([])
    const [initialLocation, setinitialLocation] = useState([])
    const [initialProvider, setinitialProvider] = useState([])
    const [claimRecord, setclaimRecord] = useState([])
    const [searchValue, setSearchValue] = useState({
        PatientName: "",
    });
    const [patientBody, setPatientBody] = useState({
        "TableName": enumUtil.enumAPITableName.Patient,
        "SearchParam": '',
    });
    const [reloadSuperSearchPatient, setReloadSuperSearchPatient] = useState(false);
    const [totalcountSummary, settotalcountSummary] = useState()

    const [viewThisPage, setViewThisPage] = useState('true')
    const [allRecordSummary, setAllRecordSummary] = useState({})

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////

    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState(0);
    const [totalCounts, setTotalCounts] = useState()
    let searchFieldData = useSelector(state => state.MainBarActiveTabsReducer?.['Reports']?.SearchField);
    console.log("searchFieldData", searchFieldData)
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    // useEffect(() => {
    //     if (isNull(searchFieldData)) {
    //         LoadData(searchParam)
    //     }
    // }, [PerPage, PageNo])
    const [dateType, setDateType] = useState(undefined);
    const [dateRange, setDateRange] = useState(null)
    useEffect(() => {
        if (!isNull(searchFieldData)) {
            if (!isNull(searchFieldData.DOSFrom)) {
                setDateRange(`${searchFieldData.DOSFrom + '-' + searchFieldData.DOSTo}`)
                setDateType('DOS')
            } else if (!isNull(searchFieldData.EntryDateFrom)) {
                setDateRange(`${searchFieldData.EntryDateFrom + '-' + searchFieldData.EntryDateTo}`)
                setDateType('EntryDate')
            }
            if (searchFieldData?.PatientList) {
                setPateintValue(searchFieldData.PatientList);
            }
            const updatedSearchParam = {
                ...searchParam,
                PatientIDs: searchFieldData.PatientIDs ? String(searchFieldData.PatientIDs) : "",
                InsuranceID: searchFieldData.InsuranceID ? String(searchFieldData.InsuranceID) : "",
                LocationID: searchFieldData.LocationID ? String(searchFieldData.LocationID) : "",
                ProviderID: searchFieldData.ProviderID ? String(searchFieldData.ProviderID) : "",
                DOSFrom: searchFieldData.DOSFrom ? searchFieldData.DOSFrom : "",
                DOSTo: searchFieldData.DOSTo ? searchFieldData.DOSTo : "",
                EntryDateFrom: searchFieldData.EntryDateFrom ? searchFieldData.EntryDateFrom : "",
                EntryDateTo: searchFieldData.EntryDateTo ? searchFieldData.EntryDateTo : "",
            };

            if (searchFieldData && searchFieldData.InsuranceID) {
                const selectedItems = !['-1', -1, '', null, undefined].includes(searchFieldData.InsuranceID) ? searchFieldData.InsuranceID.split(', ') : [];
                const data = DropdownData.Insurance.filter(item => selectedItems.includes(String(item.value)));
                setinitialInsurance(data);
            }
            if (searchFieldData && searchFieldData.LocationID) {
                const selectedItems = !['-1', -1, '', null, undefined].includes(searchFieldData.LocationID) ? searchFieldData.LocationID.split(', ') : [];
                const data = DropdownData.Location.filter(item => selectedItems.includes(String(item.value)));
                setinitialLocation(data);
            }
            if (searchFieldData && searchFieldData.ProviderID) {
                const selectedItems = !['-1', -1, '', null, undefined].includes(searchFieldData.ProviderID) ? searchFieldData.ProviderID.split(', ') : [];
                const data = DropdownData.Provider.filter(item => selectedItems.includes(String(item.value)));
                setinitialProvider(data);
            }
            setReloadSuperSearchPatient(!reloadSuperSearchPatient);
            setSearchParam(updatedSearchParam);
            dispatch(MainBarActiveTabsAction({ 'Write Off': { ActiveTabKey: 4310, SearchField: searchFieldData } }));
            LoadData(updatedSearchParam);
        }
    }, [searchFieldData]);
    const isEqual = (obj1, obj2) => {
        if (obj1 === obj2) return true;
        if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) return false;
        for (let key of keys1) {
            if (!keys2.includes(key) || !isEqual(obj1[key], obj2[key])) {
                return false;
            }
        }
        return true;
    };
    const LoadData = (searchParam) => {
        const newPageNo = (isEqual(searchParam, Search_Data) ? PageNo : 1);
        setWriteOffPatientReportData([])
        setIsLoading(true)
        ServerRequestProtected(API_Report + "/FindOverPaymentReport", 'post', {
            "TableName": enumUtil.enumAPITableName.OVERPAYMENTREPORT,
            "SEARCHCRITERIA": searchParam,
            "PerPage": PerPage,
            "PageNo": newPageNo,
        }).then((response) => {
            setIsLoading(false)
            // setGroupBy(searchParam.GroupBy)
            handleGridHeader({ defaultData: response.Rows })
            setWriteOffPatientReportData(response.Rows)
            setAllRecordSummary(response?.TotalCount)

            setTotalPages(response.count.NumOfPages);
            setTotalCounts(response.Rows.length);
            settotalcountSummary(response.count)
            let ClmData = [];
            ClmData = response.Rows.map((item, index) => {
                let newlist = { ID: item.ClaimID + "", name: item.Patient, ClaimType: item.Type === "837I" ? "I" : "P", EncounterID: item.EncounterID + "" }
                return newlist;
            })
            setclaimRecord(ClmData)
        }).catch((error) => {
            setIsLoading(false)
            setWriteOffPatientReportData('')
            setTotalCounts(0)
        })
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const summaryRow = {

        TotalCheckAmount: viewThisPage === 'false' ? allRecordSummary?.AllCheckAmount : totalcountSummary?.TotalCheckAmount,
        TotalBilled: viewThisPage === 'false' ? allRecordSummary?.AllBilled : totalcountSummary?.TotalBilled,
        TotalPaid: viewThisPage === 'false' ? allRecordSummary?.AllPaid : totalcountSummary?.TotalPaid,
        TotalOverPayment: viewThisPage === 'false' ? allRecordSummary?.AllOverPayment : totalcountSummary?.TotalOverPayment,
    };
    const bottomSummaryRows = writeOffPatientReportsData?.length > 0 ? [summaryRow] : [];

    const columns = [
        {
            key: 'Insurance',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Insurance'} sortIcon={true} type={'string'} colKey={'Insurance'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            width: 250,
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Insurance}
                            </div>
                            {row.Insurance && <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.Insurance)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>}
                            {copiedText[`${row.LineID}-${row.Insurance}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            },
            renderSummaryCell() {
                return (
                    <div className="d-flex align-items-center gap-1 za_View">
                        <p className='heading'>Total:</p>
                        <div className="d-flex gap-2">
                            <div className="ar_radio-btn d-flex align-items-center gap-1">
                                <input
                                    type="radio"
                                    name="Over_status"
                                    value="true"
                                    checked={viewThisPage === 'true'}
                                    onChange={(e) => setViewThisPage(e.target.value)}
                                />
                                <p for="Active" className="text fs-12 ar-orange-text" >This Page</p>
                            </div>
                            <div className="ar_radio-btn d-flex align-items-center gap-1">
                                <input
                                    type="radio"
                                    name="Over_status"
                                    value="false"
                                    checked={viewThisPage === 'false'}
                                    onChange={(e) => setViewThisPage(e.target.value)} />
                                <p for="InActive" className="text fs-12 ar-orange-text" >All Pages</p>
                            </div>
                        </div>
                    </div>
                )
            }
        },
        {
            key: 'CheckAmount',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Check Amount'} sortIcon={true} type={'number'} colKey={'CheckAmount'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.CheckAmount} /></>) },
            resizable: true,
            renderSummaryCell: () => {
                return (
                    <AmountFormatter amount={summaryRow?.TotalCheckAmount} />)
            }
        },
        {
            key: 'CheckDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Check Date'} sortIcon={true} type={'date'} colKey={'CheckDate'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            resizable: true,
        },
        {
            key: 'Check#',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Check #'} sortIcon={true} type={'number'} colKey={'Check#'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            resizable: true,
        },
        {
            key: 'Patient',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Patient'} sortIcon={true} type={'string'} colKey={'Patient'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            width: 200,
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Patient}
                            </div>
                            {row.Patient && <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.Patient)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>}
                            {copiedText[`${row.LineID}-${row.Patient}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'Account#',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Account #'} sortIcon={true} type={'number'} colKey={'Account#'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            resizable: true,
        },
        ...(DropdownData?.IsHomeCare === 'true' ? [
            {
                key: 'MedicaidNo',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-card'} headerName={'Medicaid #'} sortIcon={true} type={'string'} colKey={'MedicaidNo'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
                resizable: true
            },
        ] : []),
        {
            key: 'ClaimID',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Claim #'} sortIcon={true} type={'number'} colKey={'ClaimID'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            resizable: true,
            renderCell({ row }) {
                let data = {
                    name: 'Claims',
                    data: {
                        id: row.ClaimID,
                        name: row.Patient,
                        VisitType: row.ClaimType,
                        ClaimRecord: claimRecord,
                        EncounterID: row?.EncounterID,
                        PatientID: row?.PatientID,
                    }
                };
                return (
                    <>
                        <div className='slim_link copy_icon' onClick={() => handleOpenNewBrowserTab(data)}>{row.ClaimID} </div>

                    </>
                );
            },
        },
        {
            key: 'LineID',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Line ID'} sortIcon={true} type={'number'} colKey={'LineID'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            resizable: true,
        },
        {
            key: 'DOS',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'DOS'} sortIcon={true} type={'date'} colKey={'DOS'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            width: 200,
            resizable: true,
        },
        {
            key: 'Units',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Units'} sortIcon={true} type={'number'} colKey={'Units'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            resizable: true,
        },
        {
            key: 'CPT',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'CPT'} sortIcon={true} type={'number'} colKey={'CPT'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            resizable: true,
        },
        {
            key: 'Billed',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Billed'} sortIcon={true} type={'string'} colKey={'Billed'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Billed} /></>) },
            resizable: true,
            renderSummaryCell: () => {
                return (
                    <AmountFormatter amount={summaryRow?.TotalBilled} />)
            }
        },
        {
            key: 'Paid',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Paid'} sortIcon={true} type={'string'} colKey={'Paid'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Paid} /></>) },
            resizable: true,
            renderSummaryCell: () => {
                return (
                    <AmountFormatter amount={summaryRow?.TotalPaid} />)
            }
        },
        {
            key: 'OverPayment',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Over Payment'} sortIcon={true} type={'string'} colKey={'OverPayment'} data={writeOffPatientReportsData} setData={setWriteOffPatientReportData} />),
            renderCell: ({ row }) => { return (<><AmountFormatter amount={row.OverPayment} /></>) },
            resizable: true,
            renderSummaryCell: () => {
                return (
                    <AmountFormatter amount={summaryRow?.TotalOverPayment} />)
            }
        },
    ];
    const AllColumnsName = HandleSelectColumnName(columns);

    useEffect(() => {
        if (!initialLoad.current) {
            initialLoad.current = true;
            return;
        }
        LoadData(searchParam);
        handleGridHeader({ defaultData: writeOffPatientReportsData });
    }, [PerPage, PageNo]);

    const rowClass = () => {
        return "row-bg";
    };


    const searchButton = {
        AddNew: false,
        Excel: true,
        PDF: true,
        Delete: false,
        Filter: false,
        View: false
    }
    const handleMUltiSelectedData = (selectedDataArray, type, name) => {
        // console.log("selectedDataArray")
        let modal = { ...searchParam };
        if (type === 'server' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);

            modal[name] = valueValues.join(', ');
            // PatientSaveUpdateModal[name] = valueValues.join(', ');
        } else if (type === 'client' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            modal[name] = valueValues.join(', ');

            // PatientSaveUpdateModal[name] = valueValues.join(', ');
        }
        else {
            console.log("selectedDataArray");
            modal[name] = '';
            // PatientSaveUpdateModal[name] = '';
        }
        setSearchParam(modal);
        // setPatientSaveUpdateModal(PatientSaveUpdateModal);
        return selectedDataArray;
    }
    const handleClear = () => {
        setPateintValue([])
        setinitialInsurance([])
        setinitialProvider([])
        setinitialLocation([])
        setSearchParam(Search_Data)
        setReloadSuperSearchPatient(!reloadSuperSearchPatient);

    }
    return (
        <>
            <div className="container-fluid py-2">
                <div className='row align-items-end'>
                    <div className="col-md-12 hk-opt-bar">
                        <div className="row row-half row-gap-15 align-items-end">

                            <div className="col-md-3 multipleSearch-rounded rounded-full agency-pat-search">
                                <div className="input autocomplete-group autocomplete-group-xs">
                                    <label htmlFor="">Patient</label>
                                    <div className='input-group'>
                                        <SuperSearchMultiple
                                            key={reloadSuperSearchPatient}
                                            type='server'
                                            id="PatientIDs"
                                            name="PatientIDs"
                                            SuperSearchView="DetailedView"
                                            DetailedView="Patient"
                                            onSelect={handleMUltiSelectedData}    // use for get data 
                                            initialSelectedValues={patientValue} // comment here the pupose of this , whoever made his
                                            initialSelectedOptionsInstant={patientValue} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                                            tableName={enumUtil.enumAPITableName.Patient} //send Tablename api
                                            searchTerm={patientValue} //for search ipnut  // probably not getting used in this case //test it later
                                            controller={API_URL_Patient}
                                            ApiLink={"/InstantSearchWithDetails"} //api url 
                                            method='post'  //   api method 
                                            // postBody={checkBody}
                                            // onChange={handleCheckNumberChange}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 multipleSearch-rounded">
                                <div className="input">
                                    <label>Insurance</label>
                                    <SuperSearchMultipleClient
                                        key={reloadSuperSearchPatient}
                                        id="InsuranceID"
                                        name="InsuranceID"
                                        selectedOptionsDisplay='Insurance'
                                        initialSelectedValues={initialInsurance}
                                        searchParam={searchParam}
                                        setSearchParam={setSearchParam}
                                        options={DropdownData.Insurance?.filter(item => !['-1', -1].includes(item.value))}
                                        sup_btn="sup_btn-Inp"
                                        sup_inp="superSearchVisitInp"
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 multipleSearch-rounded">
                                <div className="input race">
                                    <label >Location</label>
                                    <SuperSearchMultipleClient
                                        key={reloadSuperSearchPatient}
                                        id="LocationID"
                                        name="LocationID"
                                        selectedOptionsDisplay='Location'
                                        initialSelectedValues={initialLocation}
                                        searchParam={searchParam}
                                        setSearchParam={setSearchParam}
                                        options={DropdownData.Location?.filter(item => !['-1', -1].includes(item.value))}
                                        sup_btn="sup_btn-Inp"
                                        sup_inp="superSearchVisitInp"
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 multipleSearch-rounded">
                                <div className="input race">
                                    <label >Provider</label>
                                    <SuperSearchMultipleClient
                                        key={reloadSuperSearchPatient}
                                        id="ProviderID"
                                        name="ProviderID"
                                        selectedOptionsDisplay='Provider'
                                        initialSelectedValues={initialProvider}
                                        searchParam={searchParam}
                                        setSearchParam={setSearchParam}
                                        options={DropdownData.Provider?.filter(item => !['-1', -1].includes(item.value))}
                                        sup_btn="sup_btn-Inp"
                                        sup_inp="superSearchVisitInp"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-12 hk-opt-bar">
                        <div className="row row-half row-gap-15 align-items-end mt-1">
                            <div className="col-md-3">
                                <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['DOS', 'Entry Date', 'Deposit', 'Check',]} />
                            </div>

                            <div className="col-md-2">
                                <div className="input">
                                    <label>Check #</label>
                                    <input className='form-control fc-xs rounded'
                                        name="CheckNumber"
                                        id="CheckNumber"
                                        value={searchParam.CheckNumber}
                                        onChange={(e) => { setSearchParam({ ...searchParam, CheckNumber: e.target.value }) }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-1">
                                <div className="input">
                                    <label>Claim #</label>
                                    <input className='form-control fc-xs rounded'
                                        name="ClaimID"
                                        id="ClaimID"
                                        value={searchParam.ClaimID}
                                        onChange={(e) => { setSearchParam({ ...searchParam, ClaimID: e.target.value }) }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 d-flex">
                                <div className='btns-group-flex'>
                                    <button className='btn btn-orange btn-xs no-width rounded'
                                        onClick={() => LoadData(searchParam)}
                                    >Search</button>
                                    <div className='line-border'></div>
                                    <button className='btn btn-outline btn-xs no-width rounded' onClick={() => handleClear()}>Clear</button>
                                </div>
                            </div>
                            <div className="col-md-3 ins-aging-record pad-right aging">
                                <div className="d-flex justify-content-end gap-1 align-items-center">
                                    <SearchHeader
                                        searchButton={searchButton}
                                        tableName={enumUtil.enumAPITableName.OverPayment}
                                        Name={"Over Payment"}
                                        searchParam={{ ...searchParam, IsExcelExport: "1" }}
                                        PerPage={PerPage}
                                        PageNo={PageNo}
                                        TotalPages={TotalPages}
                                        Model={"report"}
                                        isEmpty={writeOffPatientReportsData.length > 0}
                                        componentColumns={AllColumnsName}
                                        ColumnTableName={'OVERPAYMENTREPORT'}
                                        enabled={ActiveReport?.data.id === 439 && SidebarActive === 4}
                                    />
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>


            {isLoading ? <Loader /> : null}
            {show === false ? (
                <div className="table-view position-relative">
                    <Table
                        columns={columns}
                        rows={writeOffPatientReportsData}
                        bottomSummaryRows={bottomSummaryRows}
                        height="500px"
                        rowClass={rowClass}
                        // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                        // dynamicClass="fill-grid DataGrid-Table hk-exp-table  writeoff_report  hk-amt-table"
                        dynamicClass="fill-grid DataGrid-Table hk-exp-table two-rows-with-tab"
                        rowHeight={25}
                        PerPage={PerPage}
                        PageNo={PageNo}
                        TotalPages={TotalPages}
                        Counts={totalCounts}
                        handlePageClick={handlePageClick}
                        PreviousPage={PreviousPage}
                        handleFingByCreteria={handleFingByCreteria}
                        NextPage={NextPage}
                        Key={439}
                        Name={"OVERPAYMENTREPORT"}
                        // hidePagination={true}
                        isLoading={isLoading}
                        hideColClass='rows-2-tabs-hide'
                        colPopup='rows-2-tabs-hide-popup'
                        handleSelectData={handleSelectData}
                        TableName={'OVERPAYMENTREPORT'}
                        LoadData={() => LoadData(searchParam)}
                        ClearSearch={handleClear}
                    />
                </div>
            ) : null}
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}

export default connect(mapStateToProps)(OverPaymentReport)